import { type SubscriptionPlansQuery } from '@/domains/loyalty/modules/Subscriptions/generated/subscriptionPlans.query.generated';

export const hasSales = (plans: SubscriptionPlansQuery['subscriptionPlans']) =>
  plans.some((plan) => !!plan.sales);
